import {SortOrder} from "../sort-order";

export class ApplicationNotificationFilters {
  name: string;
  description: string;
  frequency: number;
  tenantUuids: string[];
  sortField: string;
  sortOrder: SortOrder;
}
